<template>
  <div class="fr-container fr-mb-4w">
    <slot />
  </div>
</template>
